import { AlertOctagon, Stethoscope } from "lucide-react";

export default function BannedResultCard({ drug }) {
  return (
    <div
      data-testid={`banned-card-${drug.id}`}
      className="fade-up bg-red-50 border-2 border-red-500 rounded-2xl p-6 sm:p-8 shadow-sm w-full max-w-3xl mx-auto text-right"
    >
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="w-16 h-16 shrink-0 text-red-600 bg-red-100 rounded-full flex items-center justify-center pulse-red">
          <AlertOctagon className="w-8 h-8" strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white text-sm font-bold tracking-tight px-3 py-1 rounded-full mb-3">
            <span>دواء مقيد</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-red-900 mb-2 break-words">
            {drug.name}
            {drug.name_en && (
              <span className="block text-[90%] font-semibold text-red-700 mt-1" dir="ltr">
                {drug.name_en}
              </span>
            )}
          </h2>

          <div className="space-y-4 mt-4">
            <div>
              <div className="text-sm font-bold tracking-tight text-red-700 mb-1">
                سبب التقييد
              </div>
              <p className="text-lg text-red-900 leading-relaxed">{drug.reason}</p>
            </div>

            <div className="bg-white/70 border-2 border-red-300 rounded-xl p-4 flex gap-3 items-start">
              <div className="w-9 h-9 shrink-0 bg-red-600 text-white rounded-lg flex items-center justify-center">
                <Stethoscope className="w-5 h-5" />
              </div>
              <div>
                <div className="text-sm font-bold tracking-tight text-red-700 mb-1">
                  إرشادات طبية
                </div>
                <p className="text-base text-red-900 leading-relaxed">
                  {drug.doctor_note}
                </p>
                <p className="mt-2 font-bold text-red-700 text-[1.215rem] sm:text-[1.518rem] leading-snug">
                  (يرجى التأكد من إضافتها إلى منصة رقيب)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
